module.exports = __webpack_public_path__ + "img/project1.2f6dcd60.png";